'use strict';

var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');

var events = {

    editLocation: function (data) {
        var rangeType = window.location.href.split('/').pop().replace('.html', '').toLowerCase();
        dataLayer.push({ 'event': 'custom.location', 'group': 'Set Location', 'category': rangeType + ' page', 'action': 'click', 'label': 'Edit' });
    },

    sidebarEditLocation: function (data) {
        dataLayer.push({ 'event': 'custom.location', 'group': 'Set Location', 'category': 'side navigation', 'action': 'click', 'label': 'Edit' });
    },

    useMyCurrentLocation: function (data) {
        var rangeType = window.location.href.split('?')[0].split('/').pop().replace('.html', '').toLowerCase();
        dataLayer.push({ 'event': 'custom.location', 'group': 'Set Location', 'category': rangeType + ' page', 'action': 'click', 'label': data.text().trim() });
    },

    sidebarUseMyCurrentLocation: function (data) {
        dataLayer.push({ 'event': 'custom.location', 'group': 'Set Location', 'category': 'side navigation', 'action': 'click', 'label': data.text().trim() });
    },

    locationPinEntered: function (data) {
        var userLocation = JSON.parse(analyticsHelper.getCookie('userloc'));
        var rangeType = window.location.href.split('?')[0].split('/').pop().replace('.html', '').toLowerCase();
        dataLayer.push({
            'event': 'custom.location', 'group': 'Set Location', 'category': rangeType + ' page',
            'action': 'set', 'label': 'confirm',
            'location': { postcode: userLocation.postalCode, formattedAddress: userLocation.summary, type: 'input' }
        });
    },

    sidebarLocationPinEntered: function (data) {
        var userLocation = JSON.parse(analyticsHelper.getCookie('userloc'));
        dataLayer.push({
            'event': 'custom.location', 'group': 'Set Location', 'category': 'side navigation',
            'action': 'set', 'label': 'confirm',
            'location': { postcode: userLocation.postalCode, formattedAddress: userLocation.summary, type: 'input' }
        });
    },

    editConfiguratorLocation: function (data) {
        dataLayer.push({ 'event': 'custom.location', 'group': 'build', 'category': 'configurator', 'action': 'click', 'label': 'Edit' });
    },

    configuratorUseMyLocation: function (data) {
        dataLayer.push({ 'event': 'custom.location', 'group': 'Set Location', 'category': 'configurator', 'action': 'click', 'label': data.text().trim() });
    },

    configuratorLocationPinEntered: function (data) {
        var inputLocation = document.getElementById('configurator-footer-location-summary')
            ? document.getElementById('configurator-footer-location-summary').textContent.trim() : '';
        var dealerName = document.getElementById('configurator-footer-dealer-name')
            ? document.getElementById('configurator-footer-dealer-name').textContent.trim() : '';
        var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
        dataLayer.push({
            'event': 'custom.location', 'group': 'Set Location', 'category': 'configurator',
            'action': 'submit', 'label': 'confirm', 'info': 'undefined',
            'data': { value: inputLocation, type: 'search' },
            'location': { postcode: locationParts ? locationParts[2] : '', formattedAddress: locationParts ? locationParts[1] : inputLocation, center: dealerName }
        });
    },

    menuLocation: function (data) {
        dataLayer.push({ 'event': 'custom.menu', 'group': 'side navigation menu', 'category': 'side navigation', 'action': 'click', 'label': 'Set your location' });
    }
};

module.exports = { events: events };
